import apiConfigs from 'app/configs/apiConfigs'

const createWithBase = (getBase) => (getURL) => (input) =>
  `${getBase()}${getURL(input)}`

const withBase = createWithBase(() => apiConfigs.apiURL)
const withBase2 = createWithBase(() => apiConfigs.apiURL2)
const withBillingBase = createWithBase(() => apiConfigs.billingApiURL)
const withBeaconBase = createWithBase(() => apiConfigs.beaconApiURL)
const withLambdaBase = createWithBase(() => apiConfigs.lambdaApiURL)
const withLambdaBaseV2 = createWithBase(() => apiConfigs.lambdaApiURL2)
const withBaseHelp = createWithBase(() => apiConfigs.healtCheck)
const withBaseManager = createWithBase(() => apiConfigs.apiURLManager)
const withBaseTrpcManager = createWithBase(() => apiConfigs.apiURLTrpcManager)
const withBaseVoucher = createWithBase(() => apiConfigs.apiURLVoucher)
const withBaseHelpManager = createWithBase(() => apiConfigs.healtCheckManager)

const withConversationBase = createWithBase(() => apiConfigs.conversationApiURL)
// const withVoucherBase = createWithBase(() => apiConfigs.voucherApiURL);
const withOpenBase = createWithBase(() => apiConfigs.openAPIURL)

const withManager = createWithBase(() => apiConfigs.managerServiceURL)

const endpoints = {
  healtCheck: withBaseHelp(() => `/health`),
  billingToken: withBillingBase((id) => `/places/${id}/token`),
  purchasePlan: withBillingBase(
    ({ placeId, planId }) => `/places/${placeId}/plans/${planId}/purchase`,
  ),
  cancelPlan: withBillingBase((placeId) => `/places/${placeId}/plans/cancel`),
  billingPaymentMethod: withBillingBase((id) => `/places/${id}/payment`),
  billingCustomer: withBillingBase((id) => `/places/${id}/customer`),
  billingVerifyPaymentMethod: withBillingBase((id) => `/places/${id}/verify`),
  billingAddress: withBillingBase((id) => `/places/${id}/address`),
  deals: withBase((id) => `/places/${id}/notifications/deals`),
  billingShippingAddress: withBase((id) => `/places/${id}/addresses`),
  updateBillingShippingAddress: withBase(
    ({ placeId, id }) => `/places/${placeId}/addresses/${id}`,
  ),
  billingRecharge: withBillingBase((id) => `/places/${id}/plans/retry-charge`),
  billingHistory: withBillingBase((id) => `/places/${id}/transactions`),
  usageHistory: withBillingBase((id) => `/places/${id}/usage-history`),
  confirmChangingPlaceEmail: withBase(() => '/places/confirm-email'),
  activate: withBase((token) => `/activate/${token}`),
  checkEmail: withBase(() => '/check-email'),
  auth: withBase(() => '/login'),
  refreshToken: withBase(() => '/refresh'),
  loginWithSSO: withOpenBase(() => '/v1/api/teams/member/verify'),
  generateAPIToken: withOpenBase(
    (placeId) => `/v1/api/places/${placeId}/generate-token`,
  ),
  my: withBase(() => '/users/my'),
  register: withBase(() => '/sign-up'),
  signOut: withBaseManager(() => '/user/sign-out'),
  forgot: withBase(() => '/forgot/reset'),
  resetPassword: withBase(() => '/forgot/set'),
  categories: withBase(() => '/categories'),
  places: withBase((id) => `/places/${id}`),
  placePublic: withBase((id) => `/places/${id}/set-place-public`),
  placeLogo: withBase((id) => `/places/${id}/logo`),
  uploadLineProfile: withBase((id) => `/places/${id}/line/upload`),
  groups: withBase((placeId) => `/places/${placeId}/groups`),
  groupsWithTags: withBase((placeId) => `/places/${placeId}/groups/tags`),
  getGroupWithSubscriber: withBase((id) => `/places/${id}/groups/subscribers`),
  subscribers: withBase((id) => `/places/${id}/subscribers`),
  subscribersCountForStatuses: withBase(
    (id) => `/places/${id}/subscribers-count-statuses`,
  ),
  notifications: withBase((id) => `/places/${id}/notifications`),
  notificationById: withBase(
    (notificationId) => `/notifications/${notificationId}`,
  ),
  getSubscriberById: withBase((subscriberId) => `/subscribers/${subscriberId}`),
  getNotificationById: withBase(
    ({ placeId, notificationId }) =>
      `/places/${placeId}/notifications/${notificationId}`,
  ),
  unsendNotification: withBase(
    (notificationId) => `/notifications/${notificationId}/unsent-status`,
  ),
  cancelEventNotification: withBase(
    (notificationId) => `/notifications/${notificationId}/cancel`,
  ),
  groupDetails: withBase((id) => `/groups/${id}`),
  groupsV4: withBase2((placeId) => `/places/${placeId}/groups`),
  groupDetailV4: withBase2(
    ({ placeId, groupId }) => `/places/${placeId}/groups/${groupId}`,
  ),
  updateGroup: withBase((id) => `/groups/${id}`),
  updateSubGroup: withBase((tagId) => `/tags/${tagId}`),
  deleteSubgroup: withBase((tagId) => `/tags/${tagId}`),
  deleteGroups: withBase(() => `/groups`),
  createGroup: withBase((placeId) => `/places/${placeId}/group`),
  bulkAssignSubscribersToGroups: withBase2(
    (placeId) => `/places/${placeId}/groups/bulk-assign`,
  ),
  addSubgroup: withBase((groupId) => `/groups/${groupId}/tags`),
  attachSubscribers: withBase((tagId) => `/tags/${tagId}/subscribers`),
  addSubscriberToTags: withBase2(
    ({ placeId, tagId }) =>
      `/places/${placeId}/tags/${tagId}/add-subscriber-tag`,
  ),
  detachSubscribersSubgroups: withBase(
    (tagId) => `/tags/${tagId}/detach-subscribers`,
  ),
  detachSubscribersFromGroup: withBase(
    (groupId) => `/groups/${groupId}/detach-subscribers`,
  ),
  createSubscriber: withBase((placeId) => `/places/${placeId}/subscribers`),
  updateSubscriber: withBase((id) => `/subscribers/${id}`),
  search: withBase(() => '/search'),
  placeLanguage: withBase((placeId) => `/places/${placeId}/languages`),
  placeLanguageCompose: withBase((placeId) => `/places/${placeId}/languages`),
  subscriberNumber: withBase(
    (placeId) => `/places/${placeId}/subscriber-number`,
  ),
  getMetricAnalytic: withBase(
    (notificationId) => `/metricAnalytic/${notificationId}`,
  ),
  getNotificationMetrics: withBase(
    ({ placeId, notificationId }) =>
      `/places/${placeId}/notifications/${notificationId}/metrics`,
  ),
  getNotificationLanguage: withBase(
    ({ notificationId }) => `/metrics/${notificationId}/language`,
  ),
  getPlaceCompletedSteps: withBase((placeId) => `/places/${placeId}/completed`),
  plans: withBase((id) => `/plans`),
  getNotifications: withBase((placeId) => `/places/${placeId}/notifications`),
  interestBeacon: withBase((placeId) => `/places/${placeId}/interests`),
  updateTeamMember: withBase(
    ({ placeId, userId }) => `/places/${placeId}/users/${userId}`,
  ),
  translate: withBase(() => `/notification/translate`),
  teamMembers: withBase((placeId) => `/places/${placeId}/users`),
  roles: withBase((placeId) => `/places/${placeId}/roles`),
  updateRole: withBase(
    ({ placeId, roleId }) => `/places/${placeId}/roles/${roleId}`,
  ),
  teamMember: withBase(
    ({ placeId, teamMemberId }) => `/places/${placeId}/users/${teamMemberId}`,
  ),
  getRandomPlaces: withBase(() => `/amazing-places`),
  getPermissions: withBase(() => `/permissions`),
  googleYoutube: (videoId) =>
    `https://www.googleapis.com/youtube/v3/videos?id=${videoId}&key=${apiConfigs.googleAPI}&part=status`,
  updateAdminPassword: withBase(() => `/users/my/password`),
  resentPlaceVerificationEmail: withBase(
    (placeId) => `/places/${placeId}/email-activation/resend`,
  ),
  cancelPlaceVerificationEmail: withBase(
    (placeId) => `/places/${placeId}/email-activation/cancel`,
  ),
  initialEmail: withBase((placeId) => `/places/${placeId}/initial-email`),
  initialSms: withBase((placeId) => `/places/${placeId}/initial-sms`),
  initialEmailPublish: withBase(
    (placeId) => `/places/${placeId}/initial-email/publish`,
  ),
  initialSmsPublish: withBase(
    (placeId) => `/places/${placeId}/initial-sms/publish`,
  ),
  notificationLanguage: withBase(
    ({ placeId, notificationId }) =>
      `/places/${placeId}/notifications/${notificationId}/languages`,
  ),
  initialNotification: withBase(
    (placeId) => `/places/${placeId}/notifications/initial-notification`,
  ),
  createComment: withBase(() => `/comments`),
  modifyComment: withBase((id) => `/comments/${id}`),
  approveSubscriber: withBase(
    (placeId) => `/places/${placeId}/subscribers/status`,
  ),
  deleteSubscribers: withBase(() => `/subscribers`),
  languages: withBase(() => '/languages'),
  qr: withBase(({ placeId, version }) => `/places/${placeId}/qr?v=${version}`),
  checkImportProcess: withBase(() => '/subscribers/check-import-process'),
  checkCSVValidationToLambda: withLambdaBase(
    (placeId) => `/places/${placeId}/check-valid-subscriber`,
  ),
  importCSVToLambda: withLambdaBase(
    (placeId) => `/places/${placeId}/import-subscriber`,
  ),
  cancelReminder: withBase((notiId) => `/notifications/${notiId}/reminder`),
  cancelScheduleNotification: withBase(
    (notiId) => `/notifications/${notiId}/cancel-schedule`,
  ),
  getAWSCognitoAuth: withBase(() => `/cognito/credentials`),
  ipapiUrl: withBaseManager(() => '/place/located'),
  settings: withBase(() => `/settings`),
  getNotiEventSubscribers: withBase(
    ({ notificationId, action }) =>
      `/notifications/${notificationId}/event-action/${action}`,
  ),
  googleLogin: withBase(() => `/google/login-url`),
  placeUserTransferRequest: withBase(
    ({ placeId }) => `/places/${placeId}/user-transfer-request`,
  ),
  userTransferRequest: withBase(
    ({ transferRequestId }) => `/user-transfer-requests/${transferRequestId}`,
  ),
  userTransferIsSeen: withBase(
    ({ transferRequestId }) =>
      `/user-transfer-requests/${transferRequestId}/is-seen`,
  ),
  getGoogleContacts: withBase(
    ({ placeId, code }) =>
      `/places/${placeId}/code/${code}/subscribers/google-import-preview`,
  ),
  importGoogleContacts: withBase(
    ({ placeId }) => `/places/${placeId}/subscribers/google-import`,
  ),
  ttsSettings: withBase(() => `/text-to-speech/settings`),
  checkAudioExists: withBase(() => `/text-to-speech/check-audio-exists`),

  // ENV DEV
  // getPlaceConversation: placeId =>
  //   `https://notify-me-conversations-dev.ifyoucan.com/v1/place/${placeId}/conversations`,
  // authConversation: () =>
  //   `https://notify-me-conversations-dev.ifyoucan.com/v1/auth/token`,
  // getConversationHistory: history_id =>
  //   `https://notify-me-conversations-dev.ifyoucan.com/v1/notification/${history_id}/messages`,
  // socketUrl: () => `https://notify-me-conversations-dev.ifyoucan.com`,

  //ENV CONV
  getPlaceConversation: withConversationBase(
    (placeId) => `/place/${placeId}/conversations`,
  ),
  authConversation: withConversationBase(() => `/auth/token`),
  getConversationDetail: withConversationBase(
    (history_id) => `/conversations/${history_id}`,
  ),
  getConversationHistory: withConversationBase(
    (history_id) => `/notification/${history_id}/messages`,
  ),
  conversationsArchive: withConversationBase(
    ({ placeId, historyId }) =>
      `/place/${placeId}/conversations/${historyId}/archive`,
  ),
  conversationsDelete: withConversationBase(
    ({ placeId, historyId }) =>
      `/place/${placeId}/conversations/${historyId}/delete`,
  ),
  socketUrl: () => process.env.REACT_APP_API_CONVERSATION,
  getBeacons: withBase((placeId) => `/places/${placeId}/beacons`),
  updateBeacon: withBase(
    ({ placeId, beaconId }) => `/places/${placeId}/beacons/${beaconId}`,
  ),
  getNotificationBeacons: withBase(
    ({ placeId }) => `/places/${placeId}/beacon-notifications`,
  ),
  updateBeaconMetrics: withBeaconBase(
    ({ placeId, beaconId }) => `/places/${placeId}/beacons/${beaconId}/metrics`,
  ),
  checkBeaconPhysicalAddress: withBeaconBase(
    (physicalAddress) => `/beacons/${physicalAddress}/metrics`,
  ),
  deleteNotificationBeacons: withBase(
    (placeId) => `/places/${placeId}/beacon-notifications/unsent`,
  ),
  createNotificationBeacon: withBase(
    (placeId) => `/places/${placeId}/beacon-notifications`,
  ),
  notificationBeaconById: withBase(
    ({ placeId, notificationId }) =>
      `/places/${placeId}/beacon-notifications/${notificationId}`,
  ),
  updateStatusNotificationBeacon: withBase(
    ({ placeId, notificationId }) =>
      `/places/${placeId}/beacon-notifications/${notificationId}/activate`,
  ),
  careCheck: withBase(({ placeId }) => `/places/${placeId}/care-check`),
  getSubscriber: withBase((subscriberId) => `/subscribers/${subscriberId}`),
  curatedPlaceSingUp: withBase(() => `/curated-place/sign-up`),
  searchRecipient: withBase((id) => `/places/${id}/search-recipient`),
  getVoucherInfo: withBase(
    ({ placeId, voucherId, parentId }) =>
      `/places/${placeId}/users/${parentId}/vouchers/${voucherId}`,
  ),
  approveRedemption: withBase(
    ({ placeId }) => `/places/${placeId}/vouchers/approve`,
  ),

  rejectRedemption: withBase(
    ({ placeId }) => `/places/${placeId}/vouchers/reject`,
  ),
  groupAndIndividualSubscribersCount: withBase(
    (id) => `/places/${id}/subscriber-count`,
  ),
  curatedCheck: withBase((googlePlaceId) => `/places/google/${googlePlaceId}`),
  getGroupCategories: withBase(() => `/group-categories`),
  updatePlaceCategory: withBase((placeId) => `/places/${placeId}/categories`),
  findJob: withBase(() => `/find-job`),
  countries: withBase(() => `/countries`),
  nationalities: withBase(() => `/nationalities`),
  getStatesByCountryId: withBase(
    (countryId) => `/countries/${countryId}/states`,
  ),
  createNotes: withBase(() => `/notes`),
  updateNotes: withBase((noteId) => `/notes/${noteId}`),
  getNotesBySubscriberId: withBase(() => `/notes`),
  deleteNoteById: withBase((noteId) => `/notes/${noteId}`),
  messageDismiss: withBase((id) => `/messages/${id}/dismiss`),
  allMessagesDismiss: withBase(
    (placeId) => `/places/${placeId}/messages/dismiss`,
  ),
  uploadImage: withBase((placeId) => `/places/${placeId}/upload`),
  uploadImageFileForCrm: withBase2(
    ({ placeId, subscriberId }) =>
      `/places/${placeId}/subscribers/${subscriberId}/uploadImageProfileCrm`,
  ),
  detectLanguage: withBase(() => `/notifications/detect-language`),
  getMemberCard: withBase((placeId) => `/places/${placeId}/membership-cards`),
  validGroupForMemberCard: withBase(
    (placeId) => `/places/${placeId}/membership-cards/groups`,
  ),
  updateMembershipCard: withBase(
    ({ placeId, id }) => `/places/${placeId}/membership-cards/${id}`,
  ),
  createMembershipCard: withBase(
    (placeId) => `/places/${placeId}/membership-cards`,
  ),
  getMemberCardOptions: withBase(
    ({ placeId, subscriberId }) =>
      `/places/${placeId}/membership-cards/${subscriberId}`,
  ),
  getSubscriberMemberCard: withBase(
    ({ placeId, subscriberId }) =>
      `/places/${placeId}/subscriber-cards/${subscriberId}`,
  ),
  // getSubscriberMemberCard: withBase(
  //   ({ placeId, subscriberId }) =>
  //     `/places/${placeId}/membership-cards/${subscriberId}`,
  // ),
  subscriberMemberCard: withBase(
    ({ placeId, subscriberId }) =>
      `/places/${placeId}/subscriber-cards/${subscriberId}`,
  ),
  subscriberMemberCardById: withBase(
    ({ placeId, subscriberId }) =>
      `/places/${placeId}/subscriber-cards/${subscriberId}`,
  ),
  deleteMembershipCard: withBase(
    ({ placeId, cardId }) => `/places/${placeId}/membership-cards/${cardId}`,
  ),
  getNotificationTimelineMetrics: withBase(
    ({ timeLineId, metricsType }) => `/metrics/${timeLineId}/${metricsType}`,
  ),
  getSubscribersExportData: withBase(
    (placeId) => `/places/${placeId}/subscribers/export`,
  ),
  translateSubscriberFullName: withBase(
    ({ placeId, subscriberId }) =>
      `/places/${placeId}/subscriber/${subscriberId}/translate`,
  ),
  setTranslatedName: withBase(
    ({ placeId, subscriberId }) =>
      `/places/${placeId}/subscriber/${subscriberId}/set-translated`,
  ),
  getDealsPromotionList: withBase(
    ({ placeId }) => `/places/${placeId}/vouchers`,
  ),
  getVoucherTemplateList: withBase(
    ({ placeId }) => `/places/${placeId}/voucher-templates`,
  ),
  createVoucher: withBase((placeId) => `/places/${placeId}/vouchers`),
  updateVoucher: withBase(
    ({ placeId, voucherId }) => `/places/${placeId}/vouchers/${voucherId}`,
  ),
  createDraftNotification: withBase(
    (placeId) => `/places/${placeId}/draft-notifications`,
  ),
  sendDraftNotification: withBase((id) => `/draft-notifications/${id}/send`),
  getDraftNotifications: withBase(
    (placeId) => `/places/${placeId}/draft-notifications`,
  ),
  getDraftNotificationsCount: withBase(
    (placeId) => `/places/${placeId}/draft-notifications/count`,
  ),
  updateDraftNotification: withBase(
    (notificationId) => `/draft-notifications/${notificationId}`,
  ),
  deleteDraftNotification: withBase(
    ({ placeId, id }) => `/places/${placeId}/draft-notifications/${id}`,
  ),
  deleteDealsPromotion: withBase(
    ({ placeId, voucherId }) => `/places/${placeId}/vouchers/${voucherId}`,
  ),
  getPlacePhotos: withBase(({ placeId }) => `/places/${placeId}/photos`),
  deletePhotos: withBase(({ placeId }) => `/places/${placeId}/delete-photos`),
  uploadPhotos: withBase(({ placeId }) => `/places/${placeId}/photos`),
  openingHours: withBase(({ placeId }) => `/places/${placeId}/opening-hours`),
  generateLandingUrl: withBase(
    ({ placeId }) => `/places/${placeId}/generate-landing-url`,
  ),
  uniqueName: withBase(({ placeId }) => `/places/${placeId}/unique-name`),
  envData: withBase(() => `/env-data`),
  cancelDealsPromotions: withBase(
    ({ placeId, voucherId }) =>
      `/places/${placeId}/vouchers/${voucherId}/cancel`,
  ),
  getVoucherView: withBase(
    ({ placeId }) => `/places/${placeId}/vouchers/preview`,
  ),
  getSocialIntegrationSettings: withBase(
    ({ placeId }) => `/places/${placeId}/social/settings`,
  ),
  connectSocialProvider: withBase(
    ({ placeId }) => `/places/${placeId}/social/login`,
  ),
  connectSocialProviderTwitter: withBase(
    ({ placeId }) => `/places/${placeId}/social/login`,
  ),
  disconnectSocialProvider: withBase(
    ({ placeId }) => `/places/${placeId}/social/disconnect`,
  ),
  updateShowLanding: withBase(
    ({ placeId, showLanding }) => `/places/${placeId}/show-landing`,
  ),
  deleteSubscribersCRMCustomField: withBase(
    (subscriberId) => `/subscribers/${subscriberId}/custom-fields`,
  ),
  getSocialProviderPages: withBase(
    ({ placeId }) => `/places/${placeId}/social/pages`,
  ),
  updateSocialPageConnectionStatus: withBase(
    ({ placeId, socialProviderKey, pageId }) =>
      `/places/${placeId}/social/${socialProviderKey}/pages/${pageId}`,
  ),
  subscriberCount: withBase((id) => `/places/${id}/subscriber-total`),
  getSubscriberCountForReceive: withBase(
    (id) => `/places/${id}/subscriber-count-receive`,
  ),
  createLanding: withBase(({ placeId }) => `/places/${placeId}/create-landing`),
  recipientCountForTimeline: withBase(
    ({ placeId, notificationId }) =>
      `/places/${placeId}/notifications/${notificationId}/recipient-count`,
  ),
  placePlanInfo: withBillingBase((placeId) => `/places/${placeId}/plan-info`),
  placeLastNotification: withBase(
    (placeId) => `/places/${placeId}/last-notification`,
  ),
  placeSubscribersGrowth: withBase(
    (placeId) => `/places/${placeId}/subscribers-growth`,
  ),
  currentPlaceNotificationsState: withBillingBase(
    (placeId) => `/places/${placeId}/plan-info`,
  ),
  getCurrentNotificationMetrics: withBase(
    (placeId, notificationId) =>
      `places/${placeId}/notifications/${notificationId}/metrics`,
  ),
  getTopicList: withBase((placeId) => `/places/${placeId}/topics`),
  createTopic: withBase((placeId) => `/places/${placeId}/topics`),
  updateTopic: withBase(
    ({ placeId, topicId }) => `/places/${placeId}/topics/${topicId}`,
  ),
  deleteTopic: withBase(({ placeId, id }) => `/places/${placeId}/topics/${id}`),
  selectedTopics: withBase(
    ({ placeId, notificationId }) =>
      `/places/${placeId}/notifications/${notificationId}`,
  ),
  notificationSocialMediaInteractions: withBase(
    ({ placeId, notificationId }) =>
      `/places/${placeId}/metrics/${notificationId}/social`,
  ),
  hideCreditModal: withBase(
    ({ placeId, status }) => `/places/${placeId}/hide-credit-modal`,
  ),
  getUsageHistoryCount: withBillingBase(
    (placeId) => `/places/${placeId}/transactions/usage`,
  ),
  advancedEditorUploadInfo: withBase(
    ({ placeId }) => `/places/${placeId}/advancedEditor/uploadInfo`,
  ),
  publicNotificationLink: withBase(
    ({ placeId, notificationId }) =>
      `/places/${placeId}/notifications/${notificationId}/public-url`,
  ),
  translationLanguage: withBase(
    ({ placeId, notificationId }) =>
      `/places/${placeId}/notifications/${notificationId}/get-translations`,
  ),
  markAsCorrectSubscriber: withBase(
    (subscriberId) => `/subscribers/${subscriberId}/mark-correct`,
  ),
  phoneValidation: withBase((placeId) => `/places/${placeId}/phone/validation`),
  getSubscribersFollowTopics: withBase(
    ({ placeId, topicsId }) =>
      `/places/${placeId}/topics/${topicsId}/following`,
  ),
  unfollowTopic: withBase(
    ({ placeId, topicsId }) => `/places/${placeId}/topics/${topicsId}/unfollow`,
  ),
  updateDisplayHistory: withBase(
    ({ placeId, notificationId }) =>
      `/places/${placeId}/notifications/${notificationId}/display-history`,
  ),
  getSubscribersTopics: withBase(
    ({ placeId }) => `/places/${placeId}/topics/subscribers`,
  ),
  subscribersFollowTopics: withBase(
    ({ placeId, topicsId }) => `/places/${placeId}/topics/${topicsId}/follow`,
  ),
  getTopicId: withBase(({ placeId }) => `/places/${placeId}/topics`),
  cancelExpiration: withBase(
    (notiId) => `/notifications/${notiId}/cancel-expire`,
  ),
  autoApproval: withBase((placeId) => `/places/${placeId}/autoapproval`),
  getAutomatedCallSetting: withBase(
    (placeId) => `/places/${placeId}/automate-call-config`,
  ),
  updateAutomatedCallSetting: withBase(
    (placeId) => `/places/${placeId}/automate-call-config`,
  ),
  getMessageRatio: withBase((id) => `/places/${id}/message-ratio`),
  getBillingPlan: withBase((placeId) => `/places/${placeId}/billing/plan`),
  getBillingAccumulateUsage: withBase(
    (placeId) => `/places/${placeId}/billing/accumulate/usage`,
  ),
  getBillingPayment: withBase(
    (placeId) => `/places/${placeId}/billing/payment`,
  ),
  getUsageLineChart: withBase(
    (placeId) => `/places/${placeId}/billing/usage/line-chart`,
  ),
  getUsageLogs: withBase((placeId) => `/places/${placeId}/usage-logs`),
  deactivate: withBase((placeId) => `/action/places/${placeId}/deactivate`),
  notificationsList: withBase2((placeId) => `/places/${placeId}/notifications`),
  ai: {
    token: withBase(({ placeId }) => `/places/${placeId}/ai/token`),
    topics: ({ placeId, language, request_id }) => {
      const url = new URL(`/v1/places/${placeId}/ai/topics`, apiConfigs.apiURL)
      if (request_id) url.searchParams.set('request_id', request_id)
      if (language) url.searchParams.set('language', language)
      return url.href
    },
    content: withBase(({ placeId }) => `/places/${placeId}/ai/content`),
    keywords: withBase(({ placeId }) => `/places/${placeId}/ai/summarize`),
    image: {
      generate: withBase(
        ({ placeId }) => `/places/${placeId}/ai/images/generations`,
      ),
      recent: withBase(({ placeId }) => `/places/${placeId}/ai/images/recent`),
    },
    languages: withBase(({ placeId }) => `/places/${placeId}/ai/languages`),
    rateMessage: withBase(({ placeId }) => `/places/${placeId}/ai/revise`),
  },
  notificationDetail: withBase2(
    ({ placeId, notiId }) => `/places/${placeId}/notifications/${notiId}`,
  ),
  notificationUnsend: withBaseTrpcManager(() => `/message.unsend`),
  getUploadFileUrl: withBase2(
    ({ placeId }) => `/places/${placeId}/subscribers-import/presign-upload`,
  ),
  importCSV: {
    validate: withLambdaBaseV2(
      ({ placeId }) => `/places/${placeId}/subscribers/validate`,
    ),
    singleValidate: withLambdaBaseV2(
      ({ placeId }) => `/places/${placeId}/subscriber/validate`,
    ),
    importSubscribers: withLambdaBaseV2(
      ({ placeId }) => `/places/${placeId}/subscribers/import`,
    ),
    cancelImport: withBase2(
      ({ placeId, importId }) =>
        `/places/${placeId}/subscribers-import/${importId}`,
    ),
    checkSubscribersImport: withBase2(
      ({ placeId }) => `/places/${placeId}/subscribers-import/check`,
    ),
    getSubscribersImportDetails: withBase2(
      ({ placeId }) => `/places/${placeId}/subscribers-import/details`,
    ),
    getSubscribersImportErrors: withBase2(
      ({ placeId, processId }) =>
        `/places/${placeId}/subscribers-import/errors?process_id=${processId}`,
    ),
  },
  importExternalSource: {
    getSISList: withBase2(({ placeId }) => `/places/${placeId}/sis-school`),
    importSubscribers: withLambdaBaseV2(
      ({ placeId }) => `/places/${placeId}/school-data`,
    ),
    getSubscribersImportDetails: withBase2(
      ({ placeId }) =>
        `/places/${placeId}/subscribers-import/details?type=veracross-import`,
    ),
    syncSettings: withBase2(
      ({ placeId }) => `/places/${placeId}/sync-settings`,
    ),
  },
  defaultInitailTemplate: withBase(
    ({ placeId }) => `/places/${placeId}/initial-template-default`,
  ),
  notificationCancelEvent: withBase2(
    (notificationId) => `/notifications/${notificationId}/cancel`,
  ),
  teamMembersV2: {
    activeTeamMembers: withBase2(
      (placeId) => `/places/${placeId}/teammember/active`,
    ),
    resendInvitedTeamMembers: withBase2(
      (placeId) => `/places/${placeId}/teammember/resend-invitation`,
    ),
    suspendTeamMembers: withBase2(
      (placeId) => `/places/${placeId}/teammember/suspend`,
    ),
  },
  poll: {
    pollByNotification: withBase2(
      ({ placeId, notificationId, pollId }) =>
        `/places/${placeId}/notifications/${notificationId}/poll/${pollId}`,
    ),
    pollVoters: withBase2(
      ({ pollId, optionId }) => `/poll/${pollId}/option/${optionId}`,
    ),
    endPoll: withBase(
      ({ placeId, notificationId }) =>
        `/places/${placeId}/notifications/${notificationId}/polls/end`,
    ),
  },
  credits: {
    get: ({ placeId }) => {
      return new URL(`v1/places/${placeId}/ai/credits`, apiConfigs.apiURL).href
    },
  },
  previewAiUsageHistory: withBase(
    ({ placeId, requestId }) =>
      `/places/${placeId}/ai/usage-logs/${requestId}/preview`,
  ),
  getUploadImageConfig: withBase(
    ({ placeId }) => `/places/${placeId}/polls/options/image/signed-url`,
  ),
  aiUsageLog: {
    getAiUsageLogt: withBase((placeId) => `/places/${placeId}/ai/usage-logs`),
    getAiUsageDetail: withBase(
      ({ placeId, requestId }) =>
        `/places/${placeId}/ai/usage-logs/${requestId}/detail`,
    ),
  },
  getSubscriberByIdV2: withBase2(
    (subscriberId) => `/subscribers/${subscriberId}`,
  ),
  getGroupForSubscriberAttach: withBase2(
    (placeId) => `/places/${placeId}/groups/tags`,
  ),
  getTopicsForSubscriberAttach: withBase2(
    (placeId) => `/places/${placeId}/topics`,
  ),
  attachTopicToSubscriber: withBase2(
    ({ placeId, subscriberId }) => `/places/${placeId}/topics/${subscriberId}`,
  ),
  attachGroupToSubscriber: withBase2(
    ({ placeId, subscriberId }) => `/places/${placeId}/tags/${subscriberId}`,
  ),
  updateProfileDetailOfSubscriber: withBase2(
    ({ placeId, subscriberId }) =>
      `/places/${placeId}/subscriber/${subscriberId}`,
  ),
  groupsV2: {
    getSubscribers: withBase2(
      ({ placeId, groupId }) =>
        `/places/${placeId}/groups/${groupId}/group-member`,
    ),
    getTagIds: withBase2(({ placeId }) => `/places/${placeId}/tag-by-group`),
  },
  subscribersV2: {
    get: withBase2((placeId) => `/places/${placeId}/subscribers`),
    delete: withBase2((placeId) => `/places/${placeId}/subscribers`),
    addOneByOne: withBase2(
      (placeId) => `/places/${placeId}/addOneByOneSubscriber`,
    ),
    invite: withBase2((placeId) => `/places/${placeId}/subscribers/invite`),
    exportSubscribers: withBase2(
      (placeId) => `/places/${placeId}/subscribers/export`,
    ),
  },
  bulkDeleteSubscribers: withBaseManager(
    (placeId) => `/place/${placeId}/subscriber/purge`,
  ),
  subscriberNotInTags: {
    get: withBase2(
      ({ placeId, tagId }) =>
        `/places/${placeId}/tags/${tagId}/subscriber-not-in-tags`,
    ),
  },
  comments: {
    comment: withBase(
      ({ placeId, notiId }) => `/places/${placeId}/${notiId}/comments`,
    ),
    commentById: withBase(
      ({ placeId, notiId, commentId }) =>
        `/places/${placeId}/${notiId}/comments/${commentId}`,
    ),
  },
  getActivity: withBase(
    ({ placeId, subscriberId }) =>
      `/places/${placeId}/subscriber/${subscriberId}/activities`,
  ),
  saveMessageAsDraft: withBaseManager(
    (placeId) => `/place/${placeId}/message/draft`,
  ),
  draftMessage: withBaseManager(
    ({ placeId, id }) => `/place/${placeId}/message/${id}/draft`,
  ),
  message: {
    metric: {
      count: withManager(
        ({ messageId }) => `/message/${messageId}/metric/count`,
      ),
      recipientsByMetrics: ({
        messageId,
        metricsType,
        pageSize,
        pageAfter,
        messageChannels,
      }) => {
        const url = new URL(
          `${apiConfigs.managerServiceURL}/message/${messageId}/metric/recipient/${metricsType}`,
        )
        if (pageSize) url.searchParams.set('page.size', pageSize)
        if (pageAfter) url.searchParams.set('page.after', pageAfter)
        if (messageChannels)
          url.searchParams.set('message_channels', messageChannels)
        return url.href
      },
    },
  },

  authV2: {
    healtCheck: withBaseHelpManager(() => `/health`),
    authVerify: withBaseManager(() => `/auth/verify`),
    verifyEmail: withBaseManager(() => `/auth/identity`),
    otpRequest: withBaseManager(() => `/auth/otp/request`),
    forgotPassword: withBaseManager(() => `/user/forgot-password`),
    resetPassword: withBaseManager(() => `/user/reset-password`),
    registration: withBaseManager(() => `/place/registration`),
    provider: withBaseManager(() => `/auth/social/identifier`),
    setPassword: withBaseManager(() => `/user/set-password`),
    transferAccount: withBaseManager(() => `/user/transfer-account`),
    changePassword: withBaseManager(() => `/user/change-password`),
    voucher: {
      approve: withBaseVoucher(() => '/manager/approve'),
      reject: withBaseVoucher(() => '/manager/reject'),
    },
    refreshTokenManager: withBaseManager(() => '/auth/refresh'),
  },
  onboarding: {
    googleCurated: withBaseManager(() => `/place/curated`),
    checkGoogleCurated: withBaseManager(() => `/place/curated/check`),
    descriptionAI: withBase(
      (placeId) => `/places/${placeId}/ai/description/generations`,
    ),
    setupPlace: withBaseManager(() => `/place/setup`),
  },
  profileInfo: {
    placeInfo: withBase2((placeId) => `/places/${placeId}/details`),
    placePublic: withBase2((placeId) => `/places/${placeId}/public`),
    openingHours: withBase2((placeId) => `/places/${placeId}/opening-hours`),
    gallery: withBase2((placeId) => `/places/${placeId}/photos`),
    landingPage: withBase2((placeId) => `/places/${placeId}/landing-page`),
    confirmNewPlaceEmail: withBase2(
      (placeId) => `/places/${placeId}/confirm-email`,
    ),
  },
  favorites: {
    add: withBaseManager((alertId) => `/message/${alertId}/add-favorites`),
    remove: withBaseManager(
      (alertId) => `/message/${alertId}/remove-favorites`,
    ),
  },
  integration: {
    getSetting: withBaseManager(
      ({ placeId }) => `/place/${placeId}/integration`,
    ),
    line: withBaseManager(
      (placeId) => `/place/${placeId}/integration/line/request`,
    ),
    lineDisconnect: withBaseManager(
      (placeId) => `/place/${placeId}/integration/line/disconnect`,
    ),
    getTwitterToken: withBaseManager(
      (placeId) => `/place/${placeId}/integration/twitter/request`,
    ),
  },
}

export default endpoints
